export default "__VITE_ASSET__d385fe19__"